export default function NumberField({ value, onChange, mode, config, ...props }) {
    if (mode === "view") return <span>{value}</span>;
    return <input 
        type="number" 
        value={value || ""} 
        onChange={e => onChange(Number(e.target.value))} 
        className="form-control"
        {...props}
    />;
  }